/* global $:false */

import { DirectUpload as ASDirectUpload } from '@rails/activestorage'
import Dropzone from 'dropzone/dist/min/dropzone.min.js'

export default class DirectUpload {
  static init () {
    Array.from($('[data-direct-upload]')).map((field) =>
      new DirectUpload($(field)))
  }

  constructor (field) {
    this.directUploadWillStoreFileWithXHR = this.directUploadWillStoreFileWithXHR.bind(this)
    this.zone = field.find('[data-direct-upload-drop-target]')[0]
    this.progressBar = field.find('[data-direct-upload-progress]')
    this.hidden = field.find('[data-direct-uploaded]')
    this.submits = field.closest('form').find('input[type=submit]')
    this.maxFiles = field.data('max-files')
    this.maxFileSize = field.data('max-file-size')
    this.acceptedFiles = field.data('accepted-files')
    const input = field.find('[data-direct-upload-url]')
    this.url = input.data('direct-upload-url')
    this.name = input.attr('name')
    this.defaultMessage = field.find('[data-dz-message]')
    input.remove()
    this.createDropzone()
  }

  uploadFile (file) {
    this.defaultMessage.hide()
    const upload = new ASDirectUpload(file, this.url, this)
    upload.create((error, blob) => {
      if (error) {
        this.enableForm()
        this.dropzone.removeFile(file)
      } else {
        this.hidden.append(this.buildHiddenField(blob.signed_id, file))
        this.enableForm()
      }
    })
  }

  buildHiddenField (value, file) {
    const field = document.createElement('input')
    field.setAttribute('type', 'hidden')
    field.setAttribute('value', value)
    field.setAttribute('data-name', file.name)
    field.setAttribute('data-size', file.size)
    field.setAttribute('data-type', file.type)
    field.name = this.name
    return field
  }

  directUploadWillStoreFileWithXHR (request) {
    request.upload.addEventListener('progress', event => {
      this.progressBar.css('width', `${(event.loaded * 100) / event.total}%`)
    })
  }

  alreadyUploadedFiles () {
    return Array.from(this.hidden.find('input')).map((input) => (
      {
        name: $(input).data('name'),
        size: $(input).data('size'),
        url: $(input).data('url'),
        type: $(input).data('type'),
        accepted: true
      }))
  }

  isDuplicateFile (aFile) {
    let twins = 0
    for (const file of Array.from(this.dropzone.files)) {
      if ((file.name === aFile.name) && (file.size === aFile.size) && (file.type === aFile.type)) {
        twins = twins + 1
      }
    }
    return twins >= 2
  }

  removeFile (file) {
    this.hidden.find(`input[type='hidden'][data-name='${file.name}']`).remove()
  }

  createDropzone () {
    Dropzone.autoDiscover = false
    this.dropzone = new Dropzone(
      this.zone,
      {
        url: this.url,
        autoQueue: false,
        maxFiles: this.maxFiles,
        maxFilesize: this.maxFileSize,
        acceptedFiles: this.acceptedFiles,
        previewTemplate: $('#template').html()
      }
    )

    this.dropzone.options.accept = (file, done) => {
      if (this.isDuplicateFile(file)) {
        done('Duplicate')
      } else {
        done()
        this.disableForm()
        this.uploadFile(file)
      }
    }

    this.dropzone.on('error', file => {
      this.dropzone.removeFile(file)
    })

    this.dropzone.on('removedfile', file => {
      if (file.accepted) {
        this.removeFile(file)
      }
    })

    // DS205: Consider reworking code to avoid use of IIFEs
    // Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md

    return (() => {
      const result = []
      for (const uploadedFile of this.alreadyUploadedFiles()) {
        this.dropzone.files.push(uploadedFile)
        this.dropzone.emit('addedfile', uploadedFile)
        result.push(this.dropzone.options.thumbnail.call(this.dropzone, uploadedFile, uploadedFile.url))
      }
      return result
    })()
  }

  disableForm () {
    this.submits.attr('disabled', 'disabled')
  }

  enableForm () {
    this.submits.removeAttr('disabled')
  }
}
